import { useState } from 'react'

import { Button } from '@ui/components/core'
import { ManagementPageStatus } from '@ui/interfaces'
import useAppNavigation from '@ui/lib/hooks/useAppNavigation'
import { useAuth } from '@ui/providers/AuthProvider'
import { RouteNamesEnum } from '@ui/router/routes'

import { Ingress } from './Ingress'
import { Instances } from './Instances'
import { Members } from './Members'

type ManagementProps = {
  initialState?: ManagementPageStatus
}

export const Management = ({ initialState }: ManagementProps) => {
  const { navigateTo } = useAppNavigation()
  const auth = useAuth()

  const { isDemoMode } = auth

  const [modalState, setModalState] = useState(false)
  const [tab, setTab] = useState(initialState || ManagementPageStatus.MEMBERS)

  const selectedTabCss =
    'whitespace-nowrap border-b-2 border-primary-500 px-1 py-3 text-sm font-medium text-primary-600 cursor-pointer'
  const unselectedTabCss =
    'whitespace-nowrap border-b-2 border-transparent px-1 py-3 text-sm font-medium text-gray-500 border-gray-400 hover:text-gray-700 cursor-pointer'

  const changeTabToUsers = () => {
    navigateTo(RouteNamesEnum.MANAGE_MEMBERS, { orgId: auth.currentOrganization!.id })
    setTab(ManagementPageStatus.MEMBERS)
  }

  const changeTabToInstances = () => {
    navigateTo(RouteNamesEnum.MANAGE_INSTANCES, { orgId: auth.currentOrganization!.id })
    setTab(ManagementPageStatus.INSTANCES)
  }

  const changeTabToSettings = () => {
    navigateTo(RouteNamesEnum.INGRESS, { orgId: auth.currentOrganization!.id })
    setTab(ManagementPageStatus.INGRESS)
  }

  if (isDemoMode) return

  return (
    <div className="mx-auto flex w-full flex-col">
      <div className="flex w-full">
        <div className="flex-auto">
          <div className="-mb-px flex space-x-8" aria-label="Tabs">
            <a
              onClick={changeTabToUsers}
              className={tab === ManagementPageStatus.MEMBERS ? selectedTabCss : unselectedTabCss}>
              Members
            </a>
            <a
              onClick={changeTabToInstances}
              className={tab === ManagementPageStatus.INSTANCES ? selectedTabCss : unselectedTabCss}>
              Instances
            </a>
            <a
              onClick={changeTabToSettings}
              className={tab === ManagementPageStatus.INGRESS ? selectedTabCss : unselectedTabCss}>
              Ingress
            </a>
          </div>
        </div>
        {(tab === ManagementPageStatus.MEMBERS || tab === ManagementPageStatus.INSTANCES) && (
          <div className="flex flex-row-reverse">
            <Button size="small" onClick={() => setModalState(true)}>
              Add {tab.toLowerCase()}
            </Button>
          </div>
        )}
      </div>

      {tab === ManagementPageStatus.MEMBERS && <Members modalState={modalState} setModalState={setModalState} />}
      {tab === ManagementPageStatus.INSTANCES && <Instances modalState={modalState} setModalState={setModalState} />}
      {tab === ManagementPageStatus.INGRESS && <Ingress />}
    </div>
  )
}
